import { ref, inject, onMounted, watch } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2617a7bf"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "basicPlanBody"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "input-desc"
}, "用户订阅到期后，若未及时续费，还可在宽限期内继续免费使用。", -1));
const _hoisted_3 = {
  class: "optionLabel"
};
const _hoisted_4 = {
  class: "optionDescribtion"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "input-desc"
}, "若更改了基础方案或者优惠方案，新的结算方案会根据您的选择生效。", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "input-desc"
}, "是否允许用户在订阅取消或者到期后重新订阅。", -1));
import { getNode } from "@/common";
export default /*#__PURE__*/_defineComponent({
  __name: 'BasicPlanAuto',
  props: {
    detail: {
      type: Object,
      default: () => {
        return {};
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const myformRef = ref(null);
    const myform = ref({
      prodBasePlan: {
        billingCycle: 'P1W',
        gracePeriod: 'P3D',
        offerChanges: '0',
        resubscribe: '10'
      }
    });
    const basePlanBillingCycleType = inject('basePlanBillingCycleType');
    const basePlanGracePeriodType = inject('basePlanGracePeriodType');
    const basePlanChangesType = inject('basePlanChangesType');
    const basePlanResubscribeType = inject('basePlanResubscribeType');
    const changePeriodList = (autoSelect = true) => {
      const billingCycle = myform.value.prodBasePlan.billingCycle;
      if (billingCycle === 'P1W') {
        basePlanGracePeriodType.value = [{
          "label": "无",
          "value": "null",
          "desc": null,
          "priority": null,
          "defaultOption": "0",
          "sort": 1,
          "children": null
        }, {
          "label": "3天",
          "value": "P3D",
          "desc": null,
          "priority": null,
          "defaultOption": "1",
          "sort": 1,
          "children": null
        }, {
          "label": "7天",
          "value": "P7D",
          "desc": null,
          "priority": null,
          "defaultOption": "0",
          "sort": 2,
          "children": null
        }];
        autoSelect && (myform.value.prodBasePlan.gracePeriod = 'P3D');
      } else if (billingCycle === 'P4W') {
        basePlanGracePeriodType.value = [{
          "label": "无",
          "value": "null",
          "desc": null,
          "priority": null,
          "defaultOption": "0",
          "sort": 1,
          "children": null
        }, {
          "label": "3天",
          "value": "P3D",
          "desc": null,
          "priority": null,
          "defaultOption": "1",
          "sort": 1,
          "children": null
        }, {
          "label": "7天",
          "value": "P7D",
          "desc": null,
          "priority": null,
          "defaultOption": "0",
          "sort": 2,
          "children": null
        }, {
          "label": "14天",
          "value": "P14D",
          "desc": null,
          "priority": null,
          "defaultOption": "0",
          "sort": 3,
          "children": null
        }];
        autoSelect && (myform.value.prodBasePlan.gracePeriod = 'P7D');
      } else {
        basePlanGracePeriodType.value = [{
          "label": "无",
          "value": "null",
          "desc": null,
          "priority": null,
          "defaultOption": "0",
          "sort": 1,
          "children": null
        }, {
          "label": "3天",
          "value": "P3D",
          "desc": null,
          "priority": null,
          "defaultOption": "1",
          "sort": 1,
          "children": null
        }, {
          "label": "7天",
          "value": "P7D",
          "desc": null,
          "priority": null,
          "defaultOption": "0",
          "sort": 2,
          "children": null
        }, {
          "label": "14天",
          "value": "P14D",
          "desc": null,
          "priority": null,
          "defaultOption": "0",
          "sort": 3,
          "children": null
        }, {
          "label": "30天",
          "value": "P30D",
          "desc": null,
          "priority": null,
          "defaultOption": "0",
          "sort": 4,
          "children": null
        }];
        autoSelect && (myform.value.prodBasePlan.gracePeriod = 'P7D');
      }
    };
    onMounted(() => {
      if (!props.detail.id) {
        changePeriodList();
      }
    });
    watch(() => props.detail, n => {
      if (n && n.prodBasePlan) {
        myform.value = n;
        if (n.id) {
          changePeriodList(false);
        }
      }
    }, {
      immediate: true,
      deep: true
    });
    // const checker = () => {
    //   myformRef.value.validate().then(async (valid: any) => {
    //     try {
    //       if (valid) {
    //         return true
    //       }
    //     } catch (error) {
    //       console.log('基本方案auto校验失败', error)
    //       return false
    //     }
    //   })
    // } // 校验输入
    // defineExpose({
    //   checker,
    // })
    return (_ctx, _cache) => {
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_form = _resolveComponent("a-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_form, {
        ref_key: "myformRef",
        ref: myformRef,
        labelWrap: true,
        model: myform.value,
        "label-col": {
          style: 'width: 114px'
        },
        autocomplete: "off"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form_item, {
          label: "结算周期",
          rules: [{
            required: true,
            type: 'string'
          }]
        }, {
          default: _withCtx(() => {
            var _props$detail;
            return [_createVNode(_component_a_select, {
              class: "inputer",
              value: myform.value.prodBasePlan.billingCycle,
              "onUpdate:value": _cache[0] || (_cache[0] = $event => myform.value.prodBasePlan.billingCycle = $event),
              options: _unref(basePlanBillingCycleType),
              disabled: __props.disabled || !!((_props$detail = __props.detail) !== null && _props$detail !== void 0 && _props$detail['id']),
              onChange: changePeriodList,
              getPopupContainer: _unref(getNode)
            }, null, 8, ["value", "options", "disabled", "getPopupContainer"])];
          }),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "宽限期",
          rules: [{
            required: true,
            type: 'string'
          }]
        }, {
          default: _withCtx(() => [_createVNode(_component_a_select, {
            class: "inputer",
            value: myform.value.prodBasePlan.gracePeriod,
            "onUpdate:value": _cache[1] || (_cache[1] = $event => myform.value.prodBasePlan.gracePeriod = $event),
            options: _unref(basePlanGracePeriodType),
            disabled: __props.disabled,
            getPopupContainer: _unref(getNode)
          }, null, 8, ["value", "options", "disabled", "getPopupContainer"]), _hoisted_2]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "客户基础方案及优惠变更",
          rules: [{
            required: true,
            type: 'string'
          }]
        }, {
          default: _withCtx(() => [_createVNode(_component_a_select, {
            class: "inputer",
            value: myform.value.prodBasePlan.offerChanges,
            "onUpdate:value": _cache[2] || (_cache[2] = $event => myform.value.prodBasePlan.offerChanges = $event),
            options: _unref(basePlanChangesType),
            disabled: __props.disabled,
            getPopupContainer: _unref(getNode)
          }, {
            option: _withCtx(({
              label,
              desc
            }) => [_createElementVNode("div", _hoisted_3, _toDisplayString(label), 1), _createElementVNode("div", _hoisted_4, _toDisplayString(desc), 1)]),
            _: 1
          }, 8, ["value", "options", "disabled", "getPopupContainer"]), _hoisted_5]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "重新订阅",
          rules: [{
            required: true,
            type: 'string'
          }]
        }, {
          default: _withCtx(() => [_createVNode(_component_a_select, {
            class: "inputer",
            value: myform.value.prodBasePlan.resubscribe,
            "onUpdate:value": _cache[3] || (_cache[3] = $event => myform.value.prodBasePlan.resubscribe = $event),
            options: _unref(basePlanResubscribeType),
            disabled: __props.disabled,
            getPopupContainer: _unref(getNode)
          }, null, 8, ["value", "options", "disabled", "getPopupContainer"]), _hoisted_6]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"])]);
    };
  }
});